import { FC } from "react";
import { handsGivingIconSVG } from "../../../../assets/SVGs/SVGs";
import { useIntl } from "react-intl";

interface loyaltyDiscountProps {
  loyaltyDiscount: { percentage: number; amount: number };
}

const LoyaltyDiscount: FC<loyaltyDiscountProps> = ({ loyaltyDiscount }) => {
  const intl = useIntl();
  return (
    <div className="mb-2 mt-4 px-4 py-3 rounded-lg flex justify-between gap-4 bg-[#EDF5E9] border-[#479821] border-solid border">
      <p className="flex gap-2 items-center">
        <span className="mt-1">{handsGivingIconSVG}</span>
        <span className="text-[#479821] font-semibold">
          {intl.formatMessage({ id: "loyalProgramDiscount" })}
        </span>
      </p>
      <p className="flex gap-2 items-center">
        <span className="font-semibold">
          {loyaltyDiscount?.amount}{" "}
          <sub>
            {intl.formatMessage({ id: "SARshort", defaultMessage: "ر.س" })}
          </sub>
        </span>
        <span className="text-[#479821]">{loyaltyDiscount?.percentage}%- </span>
      </p>
    </div>
  );
};

export default LoyaltyDiscount;
